export default "__VITE_ASSET__bf79a88a__"